import React from "react";


const Navbar = () =>{
    return(
        <>

<div id="nav-menu">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg" id="mainNav">
          <a className="navbar-brand logo" href="index-2.html">
            <span className="logo-icon mdi-bg mdi-bg-sm theme-bg-default">
              P
            </span>
            <span className="logo-text">Perennial Link</span>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#headmainmenu"
            aria-controls="headmainmenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="mdi mdi-menu" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="headmainmenu">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <a className="nav-link" href="/">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="contact-us.html">
                  About
                </a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#lu"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Services
                </a>
                <div className="dropdown-menu" data-animations="fadeInDown">
                  <a className="dropdown-item" href="services.html">
                    Event Planning
                  </a>
                  <a className="dropdown-item" href="service-single.html">
                    Food
                  </a>
                  <a className="dropdown-item" href="service-single.html">
                    Insurance
                  </a>
                  <a className="dropdown-item" href="service-single.html">
                    Hiring
                  </a>
                </div>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#lu"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Portfolio
                </a>
                <div className="dropdown-menu" data-animations="fadeInDown">
                  <a className="dropdown-item" href="portfolio.html">
                    Portfolio
                  </a>
                  <a className="dropdown-item" href="portfolio-single.html">
                    Portfolio Single
                  </a>
                </div>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#lu"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Blog
                </a>
                <div className="dropdown-menu" data-animations="fadeInDown">
                  <a className="dropdown-item" href="blog-grid.html">
                    Blog Grid
                  </a>
                  <a className="dropdown-item" href="blog-grid-side-bar.html">
                    Blog Grid - Side Bar
                  </a>
                  <a className="dropdown-item" href="blog-single-side-bar.html">
                    Blog Single - Side Bar
                  </a>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="contact-us.html">
                  Contact Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link btn theme-btn-default btn-icon easing-click"
                  href="#lu"
                >
                  <span>Get Started</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>


        </>

    )
}

export default Navbar;